import { Col, Container, Row } from "react-bootstrap";
import { Check } from "react-bootstrap-icons";
import "./payResultStyle.css";
import { Link } from "react-router-dom";

export default function Successsed() {
  return (
    <div className="bg-suces-style">
      <Container className="pt-5">
        <Row className="d-flex align-items-center justify-content-center bg-white mt-5">
          <Col className="d-flex align-items-center justify-content-center clmn-style m-5">
            <div
              className="border border-secondary rounded-circle
                        d-flex align-items-center justify-content-center"
            >
              <Check color="green" size={60} />
            </div>
            <h3 className="mt-3 text-success">تراکنش موفق </h3>
            <p>تراکنش با موفقیت انجام شد</p>
          </Col>
        </Row>
      </Container>
      <div className="d-flex align-items-center justify-content-center mt-3">
        <Link to="/" className="btn btn-success mx-1">
          صفحه اصلی
        </Link>
        <Link
          to="https://panel.avaex.ir"
          target="_blank"
          className="btn btn-success mx-1"
        >
          API پنل
        </Link>
      </div>
    </div>
  );
}
